import { render, staticRenderFns } from "./stores.vue?vue&type=template&id=4d6a95ad&scoped=true&"
import script from "./stores.vue?vue&type=script&lang=js&"
export * from "./stores.vue?vue&type=script&lang=js&"
import style0 from "./stores.vue?vue&type=style&index=0&id=4d6a95ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a95ad",
  null
  
)

export default component.exports